var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TokenLogo } from "@rozoai/intent-common";
export var HORIZON_RPC_TYPE = process.env
    .HORIZON_RPC_TYPE;
export var ASSET_ICON_URLS = {
    USDC: "https://imagedelivery.net/AKLvTMvIg6yc9W08fHl1Tg/250ccc85-8bf6-4cad-42c0-403650aa4700/public",
    EURC: "https://imagedelivery.net/AKLvTMvIg6yc9W08fHl1Tg/6fbcf6f3-a29a-4f2a-a566-667652bd7f00/public",
    USDT: TokenLogo.USDT,
    USDT0: TokenLogo.USDT0,
    XLM: "https://imagedelivery.net/AKLvTMvIg6yc9W08fHl1Tg/839e9764-9a82-4ffc-cadb-a0968a451100/public",
    POL: "https://imagedelivery.net/AKLvTMvIg6yc9W08fHl1Tg/f965214c-35f6-40a5-5553-87a44aaf9300/20x",
    ETH: "https://imagedelivery.net/AKLvTMvIg6yc9W08fHl1Tg/5dbadc94-b4be-4961-0b5b-8407f885db00/20x",
    BNB: "https://imagedelivery.net/AKLvTMvIg6yc9W08fHl1Tg/70986f2b-0f89-4dc3-21a2-7c2056b3a400/20x",
    ARB: "https://imagedelivery.net/AKLvTMvIg6yc9W08fHl1Tg/6aa9c207-0935-4d1e-0bfc-545310c44c00/20x",
    BASE: "https://imagedelivery.net/AKLvTMvIg6yc9W08fHl1Tg/870b7582-b19c-4550-15af-3d8740f59500/20x",
};
export var SUPPORTED_DEPOSIT_TOKENS = ["USDC", "USDT"];
export var SUPPORTED_DEPOSIT_CHAINS = [
    { chainId: 8453, label: "Base", iconKey: "BASE" },
    { chainId: 1, label: "Ethereum", iconKey: "ETH" },
    { chainId: 137, label: "Polygon", iconKey: "POL" },
    { chainId: 56, label: "BNB Chain", iconKey: "BNB" },
    { chainId: 42161, label: "Arbitrum", iconKey: "ARB" },
];
export var USDC_ASSET = {
    code: "USDC",
    issuer: HORIZON_RPC_TYPE === "mainnet"
        ? "GA5ZSEJYB37JRC5AVCIA5MOP4RHTM335X2KGX3IHOJAPP5RE34K4KZVN"
        : "GBBD47IF6LWK7P7MDEVSCWR7DPUWV3NY3DTQEVFL4NAT4AQH3ZLLFLA5",
};
export var EURC_ASSET = {
    code: "EURC",
    issuer: HORIZON_RPC_TYPE === "mainnet"
        ? "GDHU6WRG4IEQXM5NZ4BMPKOXHW76MZM4Y2IEMFDVXBSDP6SJY4ITNPP2"
        : "GB3Q6QDZYTHWT7E5PVS3W7FUT5GVAFC5KSZFFLPU25GO7VTC3NM2ZTVO",
};
/**
 * Tether's USDT0 on Stellar (classic asset, 7 decimals). The issuer is copied
 * from rozo-intents-api `supabase/functions/shared/canonical-token.ts`; keep it
 * in sync with that file, never retype it. USDT0 has no testnet issuer, so on
 * testnet the trustline check simply finds nothing and deposits stay blocked.
 */
export var USDT0_ASSET = {
    code: "USDT0",
    issuer: "GATISXX6BZ6NC7IKQBY37CJD4SOZL3CYZJWXEDG6JVIY4WBS6KXJHN6Q",
};
export var SUPPORTED_ASSETS = [USDC_ASSET, EURC_ASSET, USDT0_ASSET];
var ASSET_BY_CODE = {
    USDC: USDC_ASSET,
    EURC: EURC_ASSET,
    USDT0: USDT0_ASSET,
};
/**
 * Extract the Stellar asset code from a SEP-24 identifier. Accepts a bare code
 * ("USDT0"), "stellar:CODE:ISSUER", "CODE:ISSUER" and "ISSUER:CODE". A part
 * matching a supported code wins; otherwise the old heuristic is kept (second
 * part for "scheme:CODE[:ISSUER]" forms, else the last part).
 */
export function parseAssetCode(value) {
    var _a;
    var parts = String(value !== null && value !== void 0 ? value : "")
        .split(":")
        .map(function (p) { return p.trim(); })
        .filter(Boolean);
    if (parts.length === 0)
        return "";
    var known = parts.find(function (p) { return ASSET_BY_CODE[p.toUpperCase()]; });
    if (known)
        return known.toUpperCase();
    if (parts[0].toLowerCase() === "stellar" && parts[1]) {
        return parts[1].toUpperCase();
    }
    return ((_a = parts.at(-1)) !== null && _a !== void 0 ? _a : "").toUpperCase();
}
var UnsupportedAssetError = /** @class */ (function (_super) {
    __extends(UnsupportedAssetError, _super);
    function UnsupportedAssetError(code) {
        var _this = _super.call(this, "Unsupported asset \"".concat(code || "(empty)", "\". This page cannot process it.")) || this;
        _this.name = "UnsupportedAssetError";
        return _this;
    }
    return UnsupportedAssetError;
}(Error));
export { UnsupportedAssetError };
/**
 * Resolve a Stellar asset by its on-chain code. Unknown codes throw: silently
 * substituting USDC would check (and quote) the wrong asset.
 */
export function getAssetByCode(code) {
    var asset = ASSET_BY_CODE[String(code !== null && code !== void 0 ? code : "")
        .trim()
        .toUpperCase()];
    if (!asset) {
        throw new UnsupportedAssetError(code);
    }
    return asset;
}
/** User-facing names. The SEP-24 asset code stays the on-chain one (USDT0). */
var ASSET_DISPLAY = {
    USDT0: { label: "USDT0", subtitle: "USDT0 on Stellar" },
};
export function getAssetDisplayLabel(code) {
    var _a, _b;
    var upper = String(code !== null && code !== void 0 ? code : "").toUpperCase();
    return (_b = (_a = ASSET_DISPLAY[upper]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : upper;
}
export function getAssetDisplaySubtitle(code) {
    var _a;
    return (_a = ASSET_DISPLAY[String(code !== null && code !== void 0 ? code : "").toUpperCase()]) === null || _a === void 0 ? void 0 : _a.subtitle;
}
export var isUsdt0Code = function (code) {
    return String(code !== null && code !== void 0 ? code : "").toUpperCase() === USDT0_ASSET.code;
};
/** USDT0 limits (founder decision 2026-09-30): exact_in only, 2 dp, 1,000 cap. */
export var USDT0_MAX_AMOUNT = 1000;
export var USDT0_MAX_DECIMALS = 2;
/** Counterpart chains a USDT0 deposit can come from or a withdrawal can go to. */
export var USDT0_CHAINS = [
    { key: "ethereum", label: "Ethereum", chainId: 1, iconKey: "ETH" },
    { key: "solana", label: "Solana", chainId: 900, iconKey: "SOL" },
];
export function getUsdt0ChainByKey(key) {
    return USDT0_CHAINS.find(function (c) { return c.key === String(key !== null && key !== void 0 ? key : "").toLowerCase(); });
}
export function getUsdt0ChainById(chainId) {
    var id = Number(chainId);
    return USDT0_CHAINS.find(function (c) { return c.chainId === id; });
}
export var HORIZON_URL = HORIZON_RPC_TYPE === "mainnet"
    ? "https://horizon.stellar.org"
    : "https://horizon-testnet.stellar.org";
